export class LogEdicion {
    constructor(
        public fidusuario: number,
        public stipo: string,
        public Fidcarto: number,
        public soid: number,
        public sdetalle: string
    ){}
}